import React, { useMemo } from "react";
import styled from "styled-components";
import theme from "helpers/theme";
import { Grid } from "components/page";
import { MobileLayout, DesktopLayout } from "components/responsive-layouts";
import VotesList from "components/Votes/votes-list";
import PartyInfo from "components/party-info";
import MrecAd from "../components/Ads/MrecAd";

const Container = Grid.extend`
  padding: 2rem 0 3rem;
  background: ${theme.colors.pageAlt};

  @media screen and (max-width: ${theme.mobileBreakpoint}px) {
    padding: 2rem 0 3rem;
  }
`;

const VotingHistoryContainer = styled.div`
  grid-column: 2 / 9;
`;

const PartyInfoAndMrecAdsContainer = styled.div`
  display: "flex";
  flex-direction: "column";
  grid-column: 9 / 14;
`;

const PartyInfoContainer = styled.div`
  padding-left: 3rem;
  padding-top: 102px;

  @media screen and (max-width: ${theme.mobileBreakpoint}px) {
    padding: 0 18px 40px 18px;
  }
`;

const VotingSection = ({ party, votes }) => {
  const mrecMobileKey = useMemo(() =>
    `mrec-mobile-${party?.id || 'default'}`,
    [party]
  );
  const mrecDesktopKey = useMemo(() =>
    `mrec-desktop-${party?.id || 'default'}`,
    [party]
  );

  return (
    <Container>
      <MobileLayout>
        <PartyInfoAndMrecAdsContainer>
          <PartyInfoContainer>
            <PartyInfo party={party} />
          </PartyInfoContainer>

          <MrecAd key={mrecMobileKey} />
        </PartyInfoAndMrecAdsContainer>
      </MobileLayout>

      <VotingHistoryContainer>
        <VotesList votes={votes} />
      </VotingHistoryContainer>

      <DesktopLayout>
        <PartyInfoAndMrecAdsContainer>
          <PartyInfoContainer>
            <PartyInfo party={party} />
          </PartyInfoContainer>

          <MrecAd key={mrecDesktopKey} />
        </PartyInfoAndMrecAdsContainer>
      </DesktopLayout>
    </Container>
  );
};

export default VotingSection;
